import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; // 'of' no es estrictamente necesario si solo usas http
import { Survey } from '../shared/models/survey';
// Importación necesaria para SurveyResponse
import { SurveyResponse } from '../shared/models/survey-response.interface';
import { environment } from '../../environments/environment';
import { API_ENDPOINT } from '../shared/Constant/constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

    public baseUrl = environment.apiUrl;
    private apiUrl = `${this.baseUrl}${API_ENDPOINT.SURVEYS}`; // URL completa para las encuestas (ej. http://localhost:8080/api/v1/surveys)
    private apiUrlSurveyResponses = `${this.baseUrl}${API_ENDPOINT.SURVEY_RESPONSES}`; // URL para respuestas de encuestas


  constructor(private http: HttpClient) {
  }

  /**
   * Obtiene una encuesta por su ID desde el backend.
   * @param id El ID de la encuesta a buscar.
   * @returns Un Observable que emite la encuesta encontrada.
   */
  getSurveyById(id: string): Observable<Survey> {
    // Realiza una solicitud GET a la URL de la API para obtener una encuesta específica.
    // La URL será algo como: http://localhost:8080/api/v1/surveys/{id}
    return this.http.get<Survey>(`${this.apiUrl}/${id}`);
  }

   /**
   * Envía una respuesta de encuesta al backend.
   * Este método se llamará cuando el usuario presione "Enviar Información".
   * @param surveyResponse Los datos de la respuesta de la encuesta.
   * @returns Un Observable que emite la respuesta guardada por el backend.
   */
   submitSurveyResponse(surveyResponse: SurveyResponse): Observable<SurveyResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    // Realiza la solicitud POST al endpoint de respuestas de encuestas
    return this.http.post<SurveyResponse>(this.apiUrlSurveyResponses, surveyResponse, httpOptions);
  }
}